<template>
    <div>
        <div class="breadcrumb-layout" v-if="id == null">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">询盘管理</el-breadcrumb-item>
                <el-breadcrumb-item>新增询盘</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="dealInqryVoucher" :rules="checkDealInqryVoucher" ref="dealInqryVoucherForm" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">询盘名称</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title">
                            <el-input type="text" v-model="dealInqryVoucher.title" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>交易类型</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="resource">
                            <el-radio-group v-model="dealInqryVoucher.tradeType" @change="changeTradeType">
                                <el-radio class="radio mr10" :label="tradeTypeGoodsEnum.value">{{tradeTypeGoodsEnum.text}}</el-radio>
                                <el-radio class="radio" :label="tradeTypeServcEnum.value">{{tradeTypeServcEnum.text}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>询盘方式</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="resource">
                            <el-radio-group v-model="dealInqryVoucher.directed" @change="changeDirected">
                                <el-radio class="radio mr10" :label="false">公开询盘</el-radio>
                                <el-radio class="radio" :label="true">定向询盘</el-radio>
                            </el-radio-group>
                            <a class="ml10 swb-btn swb-btn-link" v-if="dealInqryVoucher.directed==true" @click="showCallbidTargetsDialog();">选择</a>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" :class="{ 'display-none': !dealInqryVoucher.directed }">
                    <div class="form-label">
                        <label>询盘商户</label>
                    </div>
                    <div class="form-value width-4x">
                        <div class="value deletable" v-for="dealInqryMercht in dealInqryVoucher.dealInqryMerchtList">
                            <span>{{dealInqryMercht.merchantName}}</span>
                            <i class="icon iconfont icon-error" @click="removeMerchant(dealInqryMercht.merchantId)"></i>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>是否直接审核</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="auditFlag">
                            <el-checkbox v-model="dealInqryVoucher.auditFlag">是</el-checkbox>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">截止日期</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="expireDate">
                            <el-date-picker type="date" placeholder="选择日期" v-model="dealInqryVoucher.expireDate" :picker-options="pickerOptions0"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">联系人</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="contactName">
                            <el-input type="text" v-model="dealInqryVoucher.contactName" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">联系电话</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="contactTel">
                            <el-input type="text" v-model="dealInqryVoucher.contactTel" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">添加地址</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="deliverStreet">
                            <swb-region :item="dealInqryVoucher" ref="swb_region" @notity-change="notityChange($event)"></swb-region>
                            <el-input type="text" style="margin-top: 3px" v-model="dealInqryVoucher.deliverStreet" placeholder="请输入详细地址"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>询盘标签</label>
                    </div>
                    <div class="form-value">
                        <el-form-item>
                            <el-input class="width-1x" type="text" v-model="dealInqryVoucher.tag" placeholder="请输入标签内容"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>描述(最大3000)</label>
                    </div>
                    <div class="form-value">
                        <swb-ck-editor v-if="id == null||content != null" ref="theCkEditor" :content="content" :imageXtHandler="imageXtHandler"></swb-ck-editor>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="simple-form" v-if="id == null">
            <div class="form-group center">
                <div class="form-label"></div>
                <div class="form-value">
                    <button class="swb-btn swb-btn-small mr10" @click="submitDealInqryVoucher">确定</button>
                    <button class="swb-btn swb-btn-small swb-btn-primary" @click="restDealInqryVoucherList()">取消</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import dealApi from '../../api/deal'

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    import { openRegionSelectDlg } from '../comn/regionSelectDlg'

    //显示（合作）供应商、服务商 选择对话框
    import { showVendorServicerSelectDialog } from '../merchant/showSelectDlg'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import { openServicerSelectComnDlg } from '../servicer/selectDlg'

    import SwbDealInqryVoucherList from './DealInqryVoucherList';
    Routes.add(SwbDealInqryVoucherList);

    export default{
        name: 'swb-deal-inqry-voucher-save',
        path: '/deal/inqry/voucher/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        parentBreadcrumbUrl: '/deal/inqry/voucher/list',
        customBreadcrumb: false,
        desc: '询盘单编辑',
        props: ['id'],
        data: function () {
            let self = this;
            let checkTitle = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('询盘名称不能为空'));
                } else {
                    callback();
                }
            };
            let checkExpireDate = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('截止日期不能为空'));
                } else {
                    callback();
                }
            };
            let checkContactName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('联系人不能为空'));
                } else {
                    callback();
                }
            };
            let checkContactTel = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('联系电话不能为空'));
                } else {
                    if(!Utils.isMobileNo(value)) {
                        return callback(new Error('必须是手机号'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                imageXtHandler: function (ckEditor) {
                    //
                    self.showDialogIntroImg(ckEditor);
                },
                tradeTypeGoodsEnum: {},
                tradeTypeServcEnum: {},
                tradeType: null,
                directed: null,
                dealInqryVoucher: {
                    directed: false,
                    tradeType: null,
                    expireDate: null,
                    dealInqryCont: {},
                    dealInqryMerchtList: [],
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                merchantTypeMap: {},
                address: {},
                addressList: [],
                content: null,
                isShow: false,
                isHidden: true,
                checkDealInqryVoucher: {
                    title: [{
                        validator: checkTitle,
                        trigger: 'blur'
                    }],
                    expireDate: [{
                        validator: checkExpireDate,
                        trigger: 'blur'
                    }],
                    contactName: [{
                        validator: checkContactName,
                        trigger: 'blur'
                    }],
                    contactTel: [{
                        validator: checkContactTel,
                        trigger: 'blur'
                    }],
                }
            }
        },
        created: function () {
            let self = this;
            let tradeTypeGoodsEnum = getEnumInfoWith('tradeType', 'name', 'Goods');
            self.tradeTypeGoodsEnum = tradeTypeGoodsEnum;
            self.tradeTypeServcEnum = getEnumInfoWith('tradeType', 'name', 'Servc');
            let merchantTypeMap = {};
            merchantTypeMap["Vendor"] = getEnumInfoWith('merchantType', 'name', 'Vendor');
            merchantTypeMap["Servicer"] = getEnumInfoWith('merchantType', 'name', 'Servicer');
            this.merchantTypeMap = merchantTypeMap;
            if(self.id != null) {
                self.getDealInqryVoucherById();
            } else {
                self.dealInqryVoucher.tradeType = tradeTypeGoodsEnum.value;
                self.tradeType = tradeTypeGoodsEnum.value;
                self.content = "";
            }
        },
        methods: {
            getDealInqryVoucherById: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealInqryVoucher(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let dealInqryVoucher = result.data;
                        self.content = dealInqryVoucher.dealInqryCont.content;
                        dealInqryVoucher.provinceId = dealInqryVoucher.deliverProvinceId;
                        dealInqryVoucher.cityId = dealInqryVoucher.deliverCityId;
                        dealInqryVoucher.countyId = dealInqryVoucher.deliverCountyId;
                        dealInqryVoucher.townId = dealInqryVoucher.deliverTownId;
                        self.tradeType = dealInqryVoucher.tradeType;
                        self.directed = dealInqryVoucher.directed;
                        self.dealInqryVoucher = dealInqryVoucher;

                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            insertImageUrlsHtml: function (ckEditor, imageUrl) {

                let imageHtmlTpl = '<span><img src="{0}" /></span><br />';
                //
                var imageHtml = imageHtmlTpl.format(imageUrl);
                ckEditor.insertHtml(imageHtml + '<br/>');

            },
            showDialogIntroImg: function (ckEditor) {
                let self = this;
                let dlg = Vue.$showDialog({
                    title: "图片 - 插入",
                    width: 400,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-file-upload :fileFor="solution" fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone"></swb-file-upload>' +
                    '</div>',
                    data: {
                        loading: false,
                        files: [],
                    },
                    okVisible: false,
                    cancelVisible: false,
                    methods: {
                        //上传前（进行验证检查）处理，可以返回false取消上传
                        onBeforeUpload: function (fileItems, uploader) {
                            if(fileItems.length === 0) {
                                this.$alert("喂，你还没选择要上传的文件吧");
                                return false;
                            }
                        },
                        //上传进度处理
                        onProgress: function (progress) {
                            let selfDelf = this;
                            selfDelf.percentage = Math.floor((progress.loaded / progress.total) * 100);
                        },
                        //上传完毕处理（根据result.type判断是否有误）
                        onUploadDone: function (result) {
                            let selfDelf = this;
                            if(result.type === "info") {
                                let files = result.data.files;
                                self.insertImageUrlsHtml(ckEditor, files[0].fileBrowseUrl);
                                dlg.close();
                            } else {
                                selfDelf.$message.error(result.message);
                            }

                        },
                    },
                    lifecycle: {}
                });
            },

            removeMerchant: function (merchantId) {
                let self = this;
                let dealInqryMerchtList = self.dealInqryVoucher.dealInqryMerchtList;
                for(let i = 0; i < dealInqryMerchtList.length; i++) {
                    let dealInqryMercht = dealInqryMerchtList[i];
                    if(dealInqryMercht.merchantId == merchantId) {
                        self.dealInqryVoucher.dealInqryMerchtList.splice(i, 1);
                    }
                }
            },
            showCallbidTargetsDialog(){
                //
                let self = this;
                let dealInqryMerchtList = this.dealInqryVoucher.dealInqryMerchtList || [];
                let sendData = [];
                let initCheckedIds = [];
                for(let i = 0; i < dealInqryMerchtList.length; i++) {
                    let dealInqryMercht = dealInqryMerchtList[i];
                    let groutingData = {};
                    groutingData.id = dealInqryMercht.merchantId;
                    groutingData.name = dealInqryMercht.merchantName;
                    sendData.add(groutingData);
                    initCheckedIds.add(dealInqryMercht.merchantId);
                }

                // 供应商
                let selMerchantType = this.dealInqryVoucher.tradeType == this.tradeTypeServcEnum.value ? this.merchantTypeMap["Servicer"].value : this.merchantTypeMap["Vendor"].value;
                let selectMerchantTypeName = selMerchantType == this.merchantTypeMap["Servicer"].value ? "服务商" : "供应商";
                //
                let callback = function (resultData) {
                    resultData = resultData || [];
                    console.log(resultData);
                    if(!Utils.isArray(resultData)) {
                        resultData = [resultData];
                    }
                    //
                    if(resultData.length < 1) {
                        MsgBox.warning("请选择 " + selectMerchantTypeName);
                        return false;
                    }
                    else {
                        //
                        let groutingMerchantList = [];
                        for(let i = 0; i < resultData.length; i++) {
                            let resultMerchant = resultData[i];
                            let groutingMerchcant = {};
                            groutingMerchcant.merchantId = resultMerchant.id;
                            groutingMerchcant.merchantName = resultMerchant.name;
                            groutingMerchantList.add(groutingMerchcant);
                        }
                        //
                        this.$set(this.dealInqryVoucher, 'dealInqryMerchtList', groutingMerchantList);
                    }
                };
                let params = {
                    initCheckedIds: initCheckedIds,
                    multiSelect: true,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showAmbilateralBizRel: true, // 双方关联
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 买方关联，备选其他
                    showNoScoreBizRel: true, // 待入围
                    showShieldedBizRel: true, // 加黑
                    showAll: true // 全部
                };
                //
                if(this.dealInqryVoucher.tradeType == this.tradeTypeServcEnum.value) {
                    // 服务商
                    openServicerSelectComnDlg(self, params, function (result) {
                        let resultData = result.checkedList || [];
                        callback.apply(self, [resultData]);
                    });
                } else {
                    //供应商
                    openVendorSelectComnDlg(self, params, function (result) {
                        let resultData = result.checkedList || [];
                        callback.apply(self, [resultData]);
                    });
                }
                //

            },
            changeTradeType: function (val) {
                let self = this;
                let tradeType = self.tradeType;
                if(!Utils.isNoB(tradeType) && tradeType != val) {
                    self.tradeType = val;
                    self.dealInqryVoucher.dealInqryMerchtList = [];
                }
            },
            changeDirected: function (val) {
                let self = this;
                let directed = self.directed;
                if(!Utils.isNoB(directed) && directed != val) {
                    self.directed = val;
                    self.dealInqryVoucher.dealInqryMerchtList = [];
                }
            },
            notityChange: function (eventData) {
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                self.$refs['dealInqryVoucherForm'].validate(function (valid) {
                    if(valid) {
                        self.content = self.$refs.theCkEditor.getContent() || '';
                        if(self.content.length > 3000) {
                            MsgBox.warning("描述不能大于3000");
                            return false;
                        }
                        let digest = self.$refs.theCkEditor.getText() || '';
                        let dealInqryVoucher = self.dealInqryVoucher;
                        let region = self.$refs.swb_region.getDlgResult() || {};
                        let deliverRegionId = region.data.regionId;
                        if(Utils.isNoB(deliverRegionId)) {
                            MsgBox.warning("请填写对应的地址信息");
                            return false
                        }
                        dealInqryVoucher.deliverRegionId = deliverRegionId;
                        let directed = dealInqryVoucher.directed;
                        if(directed) {
                            if(dealInqryVoucher.dealInqryMerchtList.length <= 0) {
                                MsgBox.warning("请选择对应的商户");
                                return false;
                            }
                        }
                        dealInqryVoucher.expireDate = dealInqryVoucher.expireDate.format('yyyy-MM-dd');
                        dealInqryVoucher.dealInqryCont.content = self.content;
                        dealInqryVoucher.digest = digest.substring(0, 500);
//                        dealInqryVoucher.dealInqryMerchtList = self.dealInqryMerchtList;
                        result.data = dealInqryVoucher;
                        result.type = "info";

                    }
                });
                return result;
            },
            submitDealInqryVoucher: function () {
                let self = this;
                let postData = {};
                self.$refs['dealInqryVoucherForm'].validate(function (valid) {
                    if(valid) {
                        self.content = self.$refs.theCkEditor.getContent() || '';
                        if(self.content.length > 3000) {
                            MsgBox.warning("描述不能大于3000");
                            return;
                        }
                        let digest = self.$refs.theCkEditor.getText() || '';
                        let dealInqryVoucher = self.dealInqryVoucher;
                        let directed = dealInqryVoucher.directed;
                        dealInqryVoucher.expireDate = dealInqryVoucher.expireDate.format('yyyy-MM-dd');
//                        let servTradeType = dealInqryVoucher.tradeType;
                        if(directed) {
                            if(dealInqryVoucher.dealInqryMerchtList.length <= 0) {
                                MsgBox.warning("请选择对应的商户");
                                return;
                            }
                        }
                        let region = self.$refs.swb_region.getDlgResult() || {};
                        let deliverRegionId = region.data.regionId;
                        if(Utils.isNoB(deliverRegionId)) {
                            MsgBox.warning("请填写对应的地址信息");
                            return;
                        }
                        dealInqryVoucher.deliverRegionId = deliverRegionId;
                        dealInqryVoucher.dealInqryCont.content = self.content;
                        dealInqryVoucher.digest = digest.substring(0, 500);
                        postData = dealInqryVoucher;
                        let lastMsgBoxDlg = MsgBox.loading();
                        dealApi.saveDealInqryVoucher(postData, function (result) {
                            lastMsgBoxDlg.close();
                            if(result.type == "info") {
                                MsgBox.success("添加成功");
                                self.returnDealInqryVoucherList(dealInqryVoucher.auditFlag);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    }
                });

            },
            restDealInqryVoucherList: function () {
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbDealInqryVoucherList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            },

            returnDealInqryVoucherList: function (auditFlag) {
                let checkState = null;
                if(!Utils.isNoB(auditFlag) && auditFlag) {
                    checkState = getEnumInfoWith('dealInqryVoucherQueryState', 'name', 'NotPublished').value;
                } else {
                    checkState = getEnumInfoWith('dealInqryVoucherQueryState', 'name', 'Initial').value;
                }
                this.$router.push({
                    path: SwbDealInqryVoucherList.path,
                    query: {
                        checkState: checkState
                    }
                });
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqryVoucherSave.vue